import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { PrCmpa, ProductCmpaService } from '../../services/product-cmpa.service';
import { ProductTypeService } from '../../services/product-type.service';
import { UnitService } from '../../services/unit.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { ActivityService } from '../../services/activity.service';
import { CustomerBillData } from '../../services/customer-bill.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-update-pr-cmpa',
  templateUrl: './update-pr-cmpa.component.html',
  styleUrls: ['./update-pr-cmpa.component.css']
})
export class UpdatePrCmpaComponent implements OnInit {

  defaultIva: number = 0;

  classError: boolean = false;
  unitError: boolean = false;
  unitErrors: boolean[] = [];
  supplierError: boolean = false;

  modalActionsCharac = new EventEmitter<string|MaterializeAction>();
  modalParamsCharac = [{dismissible: true}];
  modalActionsPrice = new EventEmitter<string|MaterializeAction>();
  modalParamsPrice = [{dismissible: true}];

  prCmpaForm: FormGroup;
    currencySelect: any[] = [];
  charactForm: FormGroup;
  priceForm: FormGroup;

  characs = [];
  prices = [];

  prTypes = {};
  units = {};
  suppliers = {};

  highestCode: {[chars: string]: string} = {};


  sid: string;
  prCmpa: any;

  prTypesInit: any;
  unitsInit: any;
  suppliersInit: any;

  subs: Subscription[] = [];

  newArray(length: number){
    return [...new Array(length)].map((u, i) => i);
  }
  constructor(
    private prCmpaService: ProductCmpaService,
    private prTypeService: ProductTypeService,
    private unitService: UnitService,
    private supplierService: CustomerSupplierService,
    private activityService: ActivityService,
    private settings: CatalogsSettingsService,
    private customerBillData: CustomerBillData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
    
    this.subs.push(
      this.settings.getPayrollSettings('1').subscribe(settings => {
        this.defaultIva = settings.defaults.iva;
      })
    );
  }

  ngOnInit() {
    this.createForm();
    this.createFormCharac();
    this.createFormPrice();
    this.subs.push(
      this.prTypeService.getPrCTypes().subscribe(prTypes => {
        const data = prTypes.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.prTypes[`${cur.name.trim()}`] = {id: cur.id, code: cur.code};
          return acc;
        }, {});
        this.prTypesInit = {
          'data': data
        };
      })
    );
    this.subs.push(
      this.unitService.getUnits().subscribe(units => {
        const data = units.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.units[`${cur.name.trim()}`] = cur.id;
          return acc;
        }, {});
        this.unitsInit = {
          'data': data
        };
      })
    );
    this.subs.push(
      this.supplierService.getSuppliers().subscribe(suppliers => {
        const data = suppliers.reduce((acc, cur) => {
          acc[`${cur.name.trim()}`] = null;
          this.suppliers[`${cur.name.trim()}`] = cur.id$;
          return acc;
        }, {});
        this.suppliersInit = {
          'data': data
        }
      })
    );
    let prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
      prCmpas.map(prCmpa => {
        console.log(prCmpa.code)
        let str: string = '';
        let num: number;
        for(let char of prCmpa.code){
          if(isNaN(+char)) str += char;
          else num = +`${num || ''}${char}`;
          console.log(str, num)
        }
        let biggest = this.highestCode[str] || '0000';
        let next = Utils.String.fillLeft(`${num + 1}`, '0', 4);
        if(biggest < next) this.highestCode[str] = next;
      });
    });
    this.subs.push(prCmpasSub);

    this.subs.push(
      this.prCmpaService.getPrCmpa(this.sid).subscribe(([data]) => {
        this.prCmpa = data;
        this.prCmpaForm.patchValue(data);
        console.log()
        
        this.prCmpaForm.get('classnId').setValue(data.data.name);
        if(data.unitRef){
          let subUnit = this.prCmpaService.getUnitDoc(data.unitRef.path).subscribe(unit => {
            subUnit.unsubscribe();
            this.prCmpaForm.get('unitName').setValue(unit.name);
          });
        }

        data.characs.map(charac => {
          const unitRef = charac.unitId.path;
          const unit = this.prCmpaService.getUnitDoc(unitRef);
          let subUnit = unit.subscribe(dataUnit => {
            charac.nameUnit = dataUnit.name;
            charac.unitId = charac.unitId.id;
            subUnit.unsubscribe();
          });
        });
        data.prices.map(price => {
          const supplierRef = price.supplierId.path;
          const supplier = this.prCmpaService.getSupplierDoc(supplierRef);
          let subSupplier = supplier.subscribe(dataSup => {
            price.supplierName = dataSup.name;
            price.supplierId = price.supplierId.id;
            subSupplier.unsubscribe();
          })
        });
        this.characs=data.characs;
        this.unitErrors = this.characs.map(() => false);
        this.prices=data.prices;
      })
    );
  }

  ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm() {
    this.prCmpaForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      activeComponent: '',
      code: ['', Validators.required],
      classnId: ['', Validators.required],
      unitName: '',
      reorderQuantity: '',
      lastPriceUsed: 0,
    });
    this.currencySelect = this.customerBillData.allSelects.currency;
  }
  createFormCharac() {
    this.charactForm = this.fb.group({
      name: ['', Validators.required],
      value: ['', Validators.required],
      unitId: ['', Validators.required],
    });
  }
  createFormPrice(){
    this.priceForm = this.fb.group({
      price: ['', Validators.required],
      supplierId: ['', Validators.required],
      usesIva: [''],
      amountIva: [''],
      currency: 'key0',
    });
  }

  addCharact({ value, valid }: { value: any, valid: boolean }) {
    value.nameUnit = value.unitId;
    value.unitId = this.units[value.unitId];  
    if(value.unitId != undefined){
      this.characs.push(value);
      this.charactForm.reset();
      this.unitError = false;
      //this.closeModalCharac();
    }else{
      this.unitError = true;
      this.charactForm.get('unitId').setValue('');
    }
  }
  changeCharacUnit(index: number){
    let charac = this.characs[index];
    charac.unitId = this.units[charac.nameUnit];  
    if(charac.unitId == undefined){
      charac.nameUnit = '';
      this.unitErrors[index] = true;
    }else{
      this.unitErrors[index] = false;
    }
  }
  deleteCharact(index) {
    this.characs.splice(index,1);
  }
  addPrice({ value, valid }: { value: any, valid: boolean }) {
    value.supplierName = value.supplierId;
    value.supplierId = this.suppliers[value.supplierId];
    if(value.amountIva == null){
      value.amountIva = 0;
    }
    if(value.supplierId != undefined){
      this.prices.push(value);
      this.closeModalPrice();
    }else{
      this.supplierError = true;
      this.priceForm.get('supplierId').setValue('');
    }
  }
  deletePrice(index) {
    this.prices.splice(index,1);
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let unitId = value.unitName ? this.units[value.unitName] : '';
    if(value.unitName && !unitId) return toast('La unidad de compra no es válida');
    delete value.unitName;
    value.unitRef = unitId ? this.unitService.getDocRef(unitId) : null;
    value.classnId = this.prTypes[value.classnId].id;
    value.characs = this.characs;
    value.prices = this.prices;
    value.name = value.name.trim();

    this.prCmpaService.updatePrCmpa(this.sid, value);
    this.activityService.updatePaperPriceByPrCmpaId(this.sid, Math.max(0, ...this.prices.map(({price}) => price) ));
  }

  onChangeClass(name: string){
    let classn = this.prTypes[name];
    this.classError = !classn;
    if(this.classError) return;
    let code = `${classn.code}-${this.highestCode[`${classn.code}-`] || '0000'}`;
    this.prCmpaForm.get('code').patchValue(code);
  }

  openModalCharac() {
    this.charactForm.reset();
    this.unitError = false;
    this.modalActionsCharac.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCharac() {
    this.modalActionsCharac.emit({ action: 'modal', params: ['close'] });
  }

  openModalPrice() {
    this.priceForm.reset();
    this.priceForm.get('usesIva').patchValue(true);
    this.priceForm.get('amountIva').patchValue(this.defaultIva);
    this.supplierError = false;
    this.modalActionsPrice.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrice() {
    this.modalActionsPrice.emit({ action: 'modal', params: ['close'] });
  }

}
